import { Component, OnInit } from '@angular/core';
import { Models } from '@ibexfusion/models';
import { CodeSnippetService } from '@services/code-snippets/code-snippet.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ScreenService } from '@services/screens/screen.service';
import { ScreenSettingsService } from '@services/screen-settings/screen-settings.service';
import { LegacyCompositionService } from '@services/legacy-compositions/legacy-composition.service';
import { PageAction } from '../../../components/page-actions/page-actions.component';
import { CodeSnippetsScreenSelectComponent } from './code-snippets-screen-select/code-snippets-screen-select.component';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-code-snippets-detail',
    templateUrl: './code-snippets-detail.component.html',
    styleUrls: ['./code-snippets-detail.component.scss'],
    providers: [CodeSnippetService, ScreenSettingsService, ScreenService, LegacyCompositionService],
    standalone: false
})
export class CodeSnippetsDetailComponent implements OnInit {

  public title = 'Code Snippets';

  public subtitle: string;

  public pageActions: PageAction[];

  codeSnippet: Models.CodeSnippet;

  public params: any;

  constructor(
    public codeSnippetService: CodeSnippetService,
    private route: ActivatedRoute,
    private router: Router,
    private dialog: MatDialog,
  ) {
  }

  ngOnInit() {
    this.codeSnippetService.get(this.route.snapshot.params['id']).then(snippet => {
      this.codeSnippet = snippet;
      this.title = this.codeSnippet.title;
      this.subtitle = this.codeSnippet.type;
    });
    this.createPageActions();
  }

  private createPageActions(): void {
    this.pageActions = [
      new PageAction({
        icon: 'subdirectory_arrow_left',
        title: 'Go to Overview',
        callback: () => {
          this.router.navigate(['code-snippets']);
        }
      }),
      new PageAction({
        icon: 'edit',
        title: 'Edit Code Snippet',
        callback: () => {
          this.router.navigate(['code-snippets/', this.route.snapshot.params['id'], 'edit']);
        }
      }),
      new PageAction({
        icon: 'format_paint',
        title: 'Creat new Code Snippet',
        callback: () => {
          this.router.navigate(['code-snippets/create']);
        }
      }),
      new PageAction({
        icon: 'desktop_windows',
        title: 'Add/Remove Screen',
        callback: () => {
          let dialogRef: MatDialogRef<CodeSnippetsScreenSelectComponent>;
          const config: MatDialogConfig = {
            height: '1000px',
            data: { codeSnippet: this.codeSnippet }
          };
          dialogRef = this.dialog.open(CodeSnippetsScreenSelectComponent, config);

          return dialogRef.afterClosed().toPromise().then(result => {
          });
        }
      })
    ];
  }
}
